import Vue from "vue";
import VueRouter from "vue-router";
import index from "../components/index.vue";
import survey from "../components/survey.vue";
import news from "../components/news.vue";
import mnews from "../components/mobile/mnews.vue";
import mculture from "../components/mobile/mculture.vue";
import mjoinus from "../components/mobile/mjoinus.vue";
import mbuild from "../components/mobile/mbuild.vue";
import build from "../components/build.vue";
import buildinfo from "../components/buildinfo.vue";
import product from "../components/product.vue";
import culture from "../components/culture.vue";
import joinus from "../components/joinus.vue";
import newsinfo from "../components/newsinfo.vue";
import search from "../components/search.vue";

import mindex from "../components/mobile/index.vue";
import mproduct from "../components/mobile/mproduct.vue";
import msearch from "../components/mobile/msearch.vue";
import mnewsinfo from "../components/mobile/mnewsinfo.vue";
import mb from "../components/mobile/mb.vue";

//重复点击路由报错的问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);
var seo_title = "中铁建工集团第一建设公司";
var seo_keywords = "中铁建工集团第一建设公司";
var seo_description = "中铁建工集团第一建设公司";
const routes = [
  //pc
  // { path: "/", redirect: "/index" },
  {
    path: "/",
    name: "index",
    component: index,
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: true, // 需要被缓存
      requiresDesktop: true, //pc标识
    },
  },
  //搜索
  {
    path: "/search",
    name: "search",
    component: search,
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/survey",
    name: "survey",
    component: survey,
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: true, // 需要被缓存
    },
  },
  //新闻
  {
    path: "/news",
    name: "news",
    component: news,
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/news/info",
    name: "newsinfo",
    component: newsinfo,
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: false, // 需要被缓存
    },
  },
  //党建
  {
    path: "/build",
    name: "build",
    component: build,
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: true, // 需要被缓存
    },
  },
  //党建详情
  {
    path: "/build/info",
    name: "buildinfo",
    component: buildinfo,
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: false, // 需要被缓存
    },
  },
  {
    path: "/product",
    name: "product",
    component: product,
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/culture",
    name: "culture",
    component: culture,
    children: [],
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/joinus",
    name: "joinus",
    component: joinus,
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: true, // 需要被缓存
    },
  },

  //mobile
  {
    path: "/mindex",
    name: "mindex",
    component: mindex,
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: true, // 需要被缓存
      requiresMobile: true,
    },
  },
  //mobile-news
  {
    path: "/mnews",
    name: "mnews",
    component: mnews,
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: true, // 需要被缓存
      requiresMobile: true,
    },
  },
  //mobile-culture
  {
    path: "/mculture",
    name: "mculture",
    component: mculture,
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: true, // 需要被缓存
      requiresMobile: true,
    },
  },
  //mobile-joinus
  {
    path: "/mjoinus",
    name: "mjoinus",
    component: mjoinus,
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: true, // 需要被缓存
      requiresMobile: true,
    },
  },
  //mobile-build
  {
    path: "/mbuild",
    name: "mbuild",
    component: mbuild,
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: true, // 需要被缓存
      requiresMobile: true,
    },
  },
  //mproduct
  {
    path: "/mproduct",
    name: "mproduct",
    component: mproduct,
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: true, // 需要被缓存
      requiresMobile: true,
    },
  },
  //msearch
  {
    path: "/msearch",
    name: "msearch",
    component: msearch,
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: true, // 需要被缓存
      requiresMobile: true,
    },
  },
  //mnewsinfo
  {
    path: "/mnewsinfo",
    name: "mnewsinfo",
    component: mnewsinfo,
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: false, // 需要被缓存
      requiresMobile: true,
    },
  }, //mb
  {
    path: "/msurvey",
    name: "mb",
    component: mb,
    meta: {
      title: seo_title,
      keywords: seo_keywords,
      description: seo_description,
      keepAlive: true, // 需要被缓存
      requiresMobile: true,
    },
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
  scrollBehavior(to, from, savePosition) {
    // return 期望滚动到哪个的位置
    return {
      y: 0,
    };
  },
});

router.beforeEach((to, form, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
    document.keywords = to.meta.keywords;
    document.description = to.meta.description;
  }
  const isMobile = window.innerWidth < 768; // 设置移动设备的屏幕分辨率阈值
  if (to.matched.some((record) => record.meta.requiresMobile) && !isMobile) {
    next("/"); // 如果路由需要移动设备而当前是桌面设备，则跳转到桌面路由
  } else if (
    to.matched.some((record) => record.meta.requiresDesktop) &&
    isMobile
  ) {
    next("/mindex"); // 如果路由需要桌面设备而当前是移动设备，则跳转到移动路由
  } else {
    next(); // 否则继续正常导航
  }
});

export default router;
